import { gql } from '@apollo/client'

// legacy = used in redux flow
export const LEGACY_CONSTANT_ENTITY_FIELDS = gql`
  fragment LegacyConstantEntityFields on ConstantEntity {
    id
    name
    createdAt
    updatedAt
  }
`
